exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thead {\r\n    font-weight: bold;\r\n}\r\n\r\n.tbody {\r\n    overflow:auto;\r\n    -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.tr.highlight\r\n{\r\n    transition: background 0.2s ease-out;\r\n    background: rgba(255,255,0,.2);\r\n}\r\n\r\n\r\n.tr{\r\n    transition: background 0.6s ease-out;\r\n    height:1.4em;\r\n    line-height: 1.4em;\r\n}\r\n\r\n.td{\r\n    padding:0.2em 0.4em;\r\n    font-size:.75em;\r\n    overflow:hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.mono{\r\n    font-family:\"Courier New\", Courier, monospace;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/src/app/payload/payload.component.css
// module id = ../../../../../src/app/payload/payload.component.css
// module chunks = 1